import React from "react";
import {
  category,
  subCategory,
  productsList,
  status,
  superCategory,
  superCategorymanager,
} from "../constants.js";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, TextField, Paper, Divider, Typography, Tooltip, FormControlLabel, Checkbox, RadioGroup, Radio, FormControl, FormLabel, Dialog, DialogTitle, DialogContent, DialogActions, Collapse, MenuItem, Icon, Box } from "@material-ui/core";
import { Close, CheckCircle, Warning, ErrorOutline, AttachFile } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from "@material-ui/lab/Alert";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import { API_GET, API_POST, API_UPLOAD } from "../../../services/api.service";
import { getManager } from "../../common/helper";
import CallbackControl from "../../Forms/CallbackControl";
import { getTemplate } from "../notificationsMessages.js";
import CallCenter from "assets/img/CallCenter.gif";


const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  blinkText: {
    animation: "$blink 1.5s infinite",
    fontSize: '18px',
    color: 'white',
  },
  "@keyframes blink": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.3 },
    "100%": { opacity: 1 },
  },
  attachmentContainer: {
    border: '2px dashed #e0e0e0',
    borderRadius: '12px',
    padding: '24px',
    textAlign: 'center',
    backgroundColor: '#fafafa',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderColor: '#3f51b5',
      backgroundColor: '#f0f2ff',
    },
  },
  fileItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    borderRadius: '8px',
    backgroundColor: '#f8f9fa',
    marginBottom: '8px',
    border: '1px solid #e0e0e0',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: '#f1f3f4',
      borderColor: '#d0d0d0',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    },
  },
  fileIcon: {
    marginRight: '12px',
    color: '#5f6368',
  },
  fileName: {
    flexGrow: 1,
    fontSize: '0.9rem',
    fontWeight: 500,
    color: '#3c4043',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  removeButton: {
    color: '#d93025',
    padding: '4px',
    '&:hover': {
      backgroundColor: 'rgba(217, 48, 37, 0.04)',
    },
  },
  fileBadge: {
    backgroundColor: '#e8f0fe',
    color: '#1967d2',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    marginLeft: '8px',
    fontWeight: 600,
  },
  blinkingLink: {
    animation: "$blink 1s step-end infinite",
    color: '#1e40af',
    textDecoration: 'none',
    fontWeight: 500,
  },
  blinkingButton: {
    animation: "$blink 1.5s infinite",
  },
  knowledgeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    background: '#f0f7ff',
    border: '1px solid #cfe0ff',
    borderRadius: 12,
    padding: '12px 16px',
    marginTop: 16,
    boxShadow: '0 2px 4px rgba(25, 103, 210, 0.05)',
  },
  knowledgeIcon: {
    fontSize: '40px !important',
    color: '#1976d2',
  },
  knowledgeTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#1976d2',
    display: 'block',
    marginBottom: 4,
  },
};
const FIELD_CONFIG = {
  category: {
    roles: ["owner", "manager", "superAdmin"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) => (
      <CustomInput
        labelText="Select Category"
        id="category"
        formControlProps={{ fullWidth: true }}
        labelProps={{ shrink: true }}
        disabled={props.isDisabledField("category")}
        inputProps={{
          disabled: props.isDisabledField("category"),
          name: "category",
          type: "select",
          value: props.value,
          onChange: props.onCategoryChange,
          options: props.user.is_superuser
            ? props.user.role === "manager"
              ? props.category.filter((v) => v.visibleToRoles && v.visibleToRoles.manager)
              : props.category
            : props.category.filter((v) => v.visibleToRoles && v.visibleToRoles.owner),
        }}
      />
    ),
  },
  product: {
    roles: ["manager", "superAdmin"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) => (
      <CustomInput
        labelText="Select Product"
        id="product"
        formControlProps={{ fullWidth: true }}
        labelProps={{ shrink: true }}
        defaultValue = "Betyphon"
        inputProps={{
          disabled: props.isDisabledField("product"),
          name: "product",
          type: "select",
          defaultValue: "Betyphon",
          value: props.value || "Betyphon",
          onChange: props.onChange,
          options: productsList,
        }}
      />
    ),
  },
  subCategory: {
    roles: ["manager", "superAdmin"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) =>
      props.notificationDetails.externalQuery ? (
        <CustomInput
          labelText="Sub Category (Concern)"
          id="subCategory"
          formControlProps={{ fullWidth: true }}
          labelProps={{ shrink: true }}
          inputProps={{
            disabled: props.isDisabledField("subCategory"),
            required: true,
            name: "subCategory",
            type: "text",
            value: props.value,
            onChange: props.onChange,
          }}
        />
      ) : (
        <CustomInput
          labelText="Select Sub Category (Concern)"
          id="subCategory"
          formControlProps={{ fullWidth: true }}
          labelProps={{ shrink: true }}
          inputProps={{
            disabled: props.isDisabledField("subCategory"),
            name: "subCategory",
            type: "select",
            value: props.value,
            onChange: props.onChange,
            options: props.subcatoption,
          }}
        />
      ),
  },
  comment: {
    roles: ["owner", "manager", "superAdmin"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) => (
      <CustomInput
        labelText="Message *"
        id="comment"
        formControlProps={{ fullWidth: true, multiline: true }}
        labelProps={{ shrink: true }}
        inputProps={{
          disabled: props.isDisabledField("comment"),
          name: "comment",
          type: "textarea",
          value: props.value,
          onChange: props.onChange,
        }}
      />
    ),
  },
  adminComment: {
    roles: ["manager", "superAdmin"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    condition: (props) => props.user.is_superuser || props.editMode,
    render: (props) => (
      <CustomInput
        labelText="Admin Comment *"
        id="adminComment"
        formControlProps={{ fullWidth: true, multiline: true }}
        labelProps={{ shrink: true }}
        inputProps={{
          disabled: props.isDisabledField("adminComment"),
          name: "adminComment",
          type: "textarea",
          value: props.value,
          onChange: props.onChange,
        }}
      />
    ),
  },
  status: {
    roles: ["superAdmin"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) => (
      <CustomInput
        labelText="Admin Status"
        id="status"
        formControlProps={{ fullWidth: true }}
        labelProps={{ shrink: true }}
        inputProps={{
          disabled: props.isDisabledField("status"),
          name: "status",
          type: "select",
          value: props.value,
          onChange: props.onChange,
          options: status,
        }}
      />
    ),
  },
  scheduledTime: {
    roles: ["superAdmin", "manager"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) => (
      <CustomInput
        labelText="Scheduled Time"
        id="scheduledTime"
        formControlProps={{ fullWidth: true }}
        labelProps={{ shrink: true }}
        inputProps={{
          disabled: props.isDisabledField("scheduledTime"),
          name: "scheduledTime",
          type: "datetime-local",
          value: props.value,
          onChange: props.onChange,
        }}
      />
    ),
  },
  sendNotify: {
    roles: ["superAdmin","manager"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) => (
      <CustomInput
        labelText="Notification"
        id="sendNotify"
        formControlProps={{ fullWidth: true }}
        labelProps={{ shrink: true }}
        inputProps={{
          disabled: props.isDisabledField("sendNotify"),
          name: "sendNotify",
          type: "checkbox",
          checked: props.value,
          onChange: props.onChange,
        }}
      />
    ),
  },
  ticketAssignedTo: {
    roles: ["superAdmin"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) => (
      <CustomInput
        labelText="Assign Ticket To"
        id="ticketAssignedTo"
        formControlProps={{ fullWidth: true }}
        labelProps={{ shrink: true }}
        inputProps={{
          disabled: props.isDisabledField("ticketAssignedTo"),
          name: "ticketAssignedTo",
          type: "select",
          value: props.value,
          onChange: props.onChange,
          options: props.ticketAssignedToOption || [],
        }}
      />
    ),
  },
  setMapping: {
    roles: ["superAdmin"],
    gridSize: { xs: 12, sm: 12, md: 12 },
    render: (props) => (
      <div style={{ marginTop: 8, marginBottom: 8 }}>

      </div>
    ),
  },
};

class SupportForm extends React.Component {
  constructor(props) {
    super(props);
    this.initState(props);
  }

  initState = (props) => {
    const { user, editMode, editId, notificationDetails, setPop, loadData, paidTicketCredits, monthlyTicketCount } = props;

    const fieldsPermission = {
      owner: ["category", "subCategory", "comment"],
      manager: [
        "category",
        "product",
        "subCategory",
        "comment",
        "adminComment",
      ],
      superAdmin: Object.keys(FIELD_CONFIG),
    };

    this.DEFAULT_DATA = {
      category: [],
      product: "Betyphon",
      subCategory: null,
      comment: "",
      status: "Pending",
      adminComment: "",
      videoLink: "",
      IsActive: true,
      createdOn: new Date(),
      updatedOn: null,
      updatedBy: null,
      plan: user.plan,
      admin: user.admin,
      user: user.username,
      userOption: null,
      externalQuery: false,
      company: user.company,
      fieldsEnables:
        fieldsPermission[
        user.username === "mark@gmail.com" ? "manager" : user.role
        ] || [],
      scheduledTime: null,
      referenceLinkRead: false,
      feedbackOption: "",
      feedbackRemarks: "",
    };

    this.state = {
      notificationDetails: notificationDetails || this.DEFAULT_DATA,
      fieldsEnables: fieldsPermission[user.role] || [],
      selectedFiles: [],
      otpNumber: null,
      editId,
      editMode,
      subcatoption: [],
      isResolved: true,
      showMappingPopup: false,
      showFeedbackForm: false,
      showScheduler: false,
      isScheduleMeeting: false,
      ticketSubmitted: false,
      activeTab: 0,
      bookingDate: new Date().toISOString().split('T')[0],
      bookingSlot: null,
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "info",
      loadingFeedback: false,
      availableSlots: [],
      loadingSlots: false,
    };
  };

  fetchAvailableSlots = async (date) => {
    if (!date) return;
    this.setState({ loadingSlots: true });
    try {
      const response = await fetch(`https://calender.betyphon.in/index.php/api/v1/availabilities?providerId=2&serviceId=1&date=${date}`, {
        headers: {
          'accept': 'application/json',
          'Authorization': 'Bearer 3242424f32r3f24242342f3r2323'
        }
      });
      const data = await response.json();
      if (Array.isArray(data)) {
        const processedSlots = this.processSlotsFor30Min(data);
        this.setState({ availableSlots: processedSlots, loadingSlots: false });
      } else {
        this.setState({ availableSlots: [], loadingSlots: false });
      }
    } catch (error) {
      console.error("Error fetching available slots:", error);
      this.setState({ availableSlots: [], loadingSlots: false });
      this.showNotification("Failed to fetch available slots", "error");
    }
  };

  processSlotsFor30Min = (apiSlots) => {
    const { bookingDate } = this.state;
    const now = new Date();
    const isToday = bookingDate === now.toISOString().split('T')[0];

    return apiSlots
      .filter(startTime => {
        if (!isToday) return true;
        
        const [h, m] = startTime.split(':').map(Number);
        const slotDate = new Date();
        slotDate.setHours(h, m, 0, 0);
        
        // Only include slots that are at least 15 minutes in the future
        return slotDate.getTime() > (now.getTime() + 15 * 60000);
      })
      .map(startTime => {
        const [h, m] = startTime.split(':').map(Number);
        const endMins = h * 60 + m + 30;
        const endH = Math.floor(endMins / 60);
        const endM = endMins % 60;
        const endTime = `${String(endH).padStart(2, "0")}:${String(endM).padStart(2, "0")}`;
        return `${this.formatTo12Hour(startTime)} - ${this.formatTo12Hour(endTime)}`;
      });
  };

  formatTo12Hour = (time24) => {
    const [h, m] = time24.split(':').map(Number);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const h12 = h % 12 || 12;
    return `${h12}:${String(m).padStart(2, '0')} ${ampm}`;
  };

  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

  showNotification = (message, severity = "info") => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  toggleBookCall = () => {
    this.setState((prevState) => {
      const showScheduler = !prevState.showScheduler;
      if (showScheduler && prevState.bookingDate) {
        this.fetchAvailableSlots(prevState.bookingDate);
      }
      return { showScheduler };
    });
  };

  handleBookingDateChange = (event) => {
    const date = event.target.value;
    this.setState({ bookingDate: date, bookingSlot: null });
    this.fetchAvailableSlots(date);
  };

  handleSelectBookingDate = (dateIso) => {
    this.setState({ bookingDate: dateIso, bookingSlot: null });
    this.fetchAvailableSlots(dateIso);
  };

  handleSlotSelect = (slot) => {
    this.setState({ bookingSlot: slot });
  };

  componentDidMount() {
    const { editMode, editId } = this.props;
    this.getCategory().then(() => {
      // Call editRecord after categories are loaded
      if (editMode && editId) {
        this.editRecord(editId);
      }
    });
    if (this.state.bookingDate) {
      this.fetchAvailableSlots(this.state.bookingDate);
    }
  }

  getCategory = async () => {
    try {
      const registerRequest = await API_POST("action/getdata", {
        root: "supportCategories",
        con: {},
      });

      if (registerRequest.data && registerRequest.data[0]) {
        const record = registerRequest.data;
        const category = record.map((v) => {
          return { key: v.categoryName, value: v.categoryName, visibleToRoles: v.visibleToRoles };
        });
        this.setState({ category: category, categoryData: record });
      }
    } catch (error) {
      console.error("Error editing record:", error);
    }
  };

  isDisabledField = (field) => {
    const managerDisabledField = [
      "category",
      "subCategory",
      "product",
      "comment",
    ];
    const { user } = this.props;
    console.log("user", user);
    if (user.role === "agent" && managerDisabledField.includes(field)) {
      return true;
    }
    return false;
  };

  editRecord = async (id) => {
    try {
      const { data } = await API_POST("action/getdata", {
        root: "supportTickets",
        con: { _id: id },
      });

      if (data[0]) {
        const record = data[0];

        // Get subcategory options based on the category
        let subcatoption = [];
        if (record.category) {
          const categoryData = this.state.categoryData || [];
          const selectedCategory = categoryData.find((item) => item.categoryName === record.category);

          if (selectedCategory && selectedCategory.subcategories) {
            subcatoption = selectedCategory.subcategories.map((item) => ({
              key: item.name,
              value: item.name,
            }));
          } else {
            // Fallback to static subCategory if categoryData is not available
            const staticSubCategories = subCategory[record.category];
            if (staticSubCategories) {
              subcatoption = staticSubCategories.map((item) => ({
                key: item,
                value: item,
              }));
            }
          }
        }

        this.setState({
          notificationDetails: record,
          subcatoption,
        });
      }
    } catch (error) {
      console.error("Error editing record:", error);
    }
  };

  handleChange = (e) => {
    const { name, value, type, checked, id } = e.target;
    const { notificationDetails } = this.state;

    if(name === "subCategory"){
      // knowledgeLink
      const subcat =  this.state.categoryData.find((item) => item.categoryName === notificationDetails.category) || [];
      const subcategory = subcat.subcategories.find((item) => item.name === value);
      console.log("subcategory", subcategory,subcat);
      this.setState({
        knowledgeLink: subcategory.link,
        videoLink: subcategory.videoLink,
      })
      notificationDetails.knowledgeLink = subcategory.link
      notificationDetails.isPaid = subcategory.isPaid
      notificationDetails.needFeedback = subcategory.needFeedback
      notificationDetails.scheduleMeeting = subcategory.scheduleMeeting

    }

    const updatedDetails = {
      ...notificationDetails,
      [type === "checkbox" ? id : name]:
        type === "checkbox" ? checked : value === "" ? null : value,
    };

    console.log("updatedDetails", updatedDetails);

    this.setState({
      isResolved: name === "status" && value === "Resolved",
      notificationDetails: updatedDetails,
    });
  };

  categoryChange = (e) => {
    const categoryValue = e.target.value;

    const subcat = this.state.categoryData.find((item) => item.categoryName === categoryValue) || subCategory[categoryValue] || [];
    console.log("subcat", subcat, this.state.categoryData);

    let subcatoption = [];
    if (subcat.subcategories) {
      subcatoption = subcat.subcategories.map((item) => ({
        key: item.name,
        value: item.name,
      }));
    } else if (Array.isArray(subcat)) {
      // Fallback for static subCategory array
      subcatoption = subcat.map((item) => ({
        key: item,
        value: item,
      }));
    }

    this.setState((prevState) => ({
      notificationDetails: {
        ...prevState.notificationDetails,
        category: categoryValue,
        subCategory: null,
      },
      subcatoption,
    }));
  };

  changesubcat = (e) => {
    this.setState((prevState) => ({
      notificationDetails: {
        ...prevState.notificationDetails,
        subCategory: e.target.value,
      },
    }));
  };

  changeAdmin = (data) => {
    if (data) {
      this.setState((prevState) => ({
        notificationDetails: {
          ...prevState.notificationDetails,
          selectAdminObj: data,
          admin: data.title,
          user: data.title,
          company: data.data.company,
          phone: data.data.phone,
        },
      }));
    }
  };

  handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    this.setState((prevState) => ({
      selectedFiles: [...prevState.selectedFiles, ...files],
    }));
  };

  handleRemoveSelectedFile = (index) => {
    this.setState((prevState) => ({
      selectedFiles: prevState.selectedFiles.filter((_, i) => i !== index),
    }));
  };

  handleremoveattachment = (row) => {
    this.setState((prevState) => ({
      notificationDetails: {
        ...prevState.notificationDetails,
        attachments:
          prevState.notificationDetails.attachments.filter(
            (v) => v.fileName !== row.fileName
          ) || [],
      },
    }));
  };

  handleSave = async (e) => {
    e.preventDefault();
    const { user, editMode, editId, paidTicketCredits } = this.props;
    const { notificationDetails, selectedFiles, otpNumber } = this.state;
    let formValue = { ...notificationDetails };

    // Validation checks

    if (
      user.is_superuser &&
      formValue.status === "Followups" &&
      !formValue.scheduledTime
    ) {
      alert("Scheduled time is mandatory");
      return;
    }

    if (
      formValue.status === "Resolved" &&
      (otpNumber != formValue.otp || !otpNumber)
    ) {
      console.log("otp", otpNumber, formValue);
      alert("OTP verification failed");
      return;
    }

    if (
      !formValue.user ||
      !formValue.comment ||
      !formValue.category ||
      !formValue.subCategory
    ) {
      this.showNotification("Please fill all mandatory fields", "error");
      return;
    }

    if (formValue.scheduleMeeting && (!this.state.bookingDate || !this.state.bookingSlot)) {
      this.showNotification("Schedule Date & time selection is mandatory to submit the tickets", "error");
      return;
    }

    // Check if reference link checkbox is checked

    console.log("formValue", formValue, notificationDetails.knowledgeLink);

    if (user.is_superuser && editMode && !formValue.adminComment) {
      alert("Please add admin comment");
      return;
    }




    try {
      // Set timestamps
      formValue = {
        ...formValue,
        ...(!editMode
          ? { createdOn: new Date() }
          : {
            updatedOn: new Date(),
            updatedBy: user.username,
          }),
        ...(formValue.status === "Resolved" && { resolvedOn: new Date() }),
      };

      await this.saveTicketToDatabase(formValue, editMode, editId);

      this.setState({
        notificationDetails: this.DEFAULT_DATA,
        selectedFiles: [],
        bookingDate: new Date().toISOString().split('T')[0],
        bookingSlot: null,
      });
      this.props.loadData(0);
      //this.props.setPop();

    } catch (error) {
      console.error("Error saving ticket:", error);
    }
  };

  sendNotification = async ({ data, userType, email, phone, scheduledTime }) => {
    try {
      const templateData = { ...data };
      if (scheduledTime) {
        templateData.scheduledTime = scheduledTime;
      }
      const { html, message, subject } = getTemplate(templateData, userType);
      let tou = email;

      //  tou += ",m";

      await API_POST("commPublic/sendMessages", {
        phone,
        tou,
        bcc: "Support@techmet,in",
        type: ["email", "whatsapp"],
        from: "betyphon.crm@gmail.com",
        to: tou,
        email: tou,
        subject,
        message: message,
        html: html,
      });
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };


  notificationBell = async ({ admin, message, status, category, manager, customer }) => {
    try {
      await API_POST("action/addRecord", {
        root: "notifications",
        body: {
          type: "support-ticket",
          IsActive: true,
          read: 0,
          admin,
          user: admin,
          version: "1.0",
          customer,
          status,
          category,
          manager,
          message,
          link: this.props.editMode ? this.props.editId : null,
          createdOn: new Date(),
        },
      });
    } catch (error) {
      console.error("Error creating notification:", error);
    }
  };

  sendOtp = async () => {
    const { notificationDetails } = this.state;
    const val = Math.floor(1000 + Math.random() * 9000);

    try {
      await API_POST("commPublic/sendMessages", {
        phone: notificationDetails.customerPhone || notificationDetails.phone,
        bcc: "Support@techmet,in",
        type: ["sms", "whatsapp"],
        from: "betyphon.crm@gmail.com",
        message: `BTYPHN - Dear User, Your OTP is ${val} for BeTyphon`,
      });

      this.setState({ otpNumber: val });
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  handleChangeCallback = (date) => {
    this.setState((prevState) => ({
      notificationDetails: {
        ...prevState.notificationDetails,
        scheduledTime: new Date(date),
      },
    }));
  };

  handleCancel = () => { };

  // Shared method for saving ticket to database
  saveTicketToDatabase = async (formValue, editMode = false, editId = null) => {
    const { user , paidTicketCredits, monthlyTicketCount } = this.props;

    try {


      // Set timestamps
      const finalFormValue = {
        ...formValue,
        ...(editMode 
          ? { updatedOn: new Date(), updatedBy: user.username }
          : { createdOn: new Date() }),
        ...(formValue.status === "Resolved" && { resolvedOn: new Date() }),
      };

      if (!editMode && !user.is_superuser && finalFormValue.isPaid && monthlyTicketCount <= 0) {
        if ( monthlyTicketCount <= 0 && paidTicketCredits <= 0) {
          this.showNotification("You have reached the FREE tickets quota, Connect with BeTyphon Support Team to buy Paid Ticket - Reach us 1800-120-6389 support@techmet.in.", "warning");
          return;
        }
      }

      // Check for allocated RM
      const allocatedRm = await API_GET(
        `register/GetProfileData?username=${finalFormValue.admin}`
      );
      if (allocatedRm.success && allocatedRm.data.allocatedRm) {
        finalFormValue.assignTo = allocatedRm.data.allocatedRm.email;
        user.allocatedToRM = allocatedRm.data.allocatedRm;
      }

      // Handle file uploads if any
      if (this.state.selectedFiles.length) {
        const formData = new FormData();
        this.state.selectedFiles.forEach((file, index) => {
          formData.append(`myFile${index + 1}`, file);
        });
        formData.append("admin", user.admin);
        formData.append("id", editId || null);
        formData.append("root", "supportTickets");

        const uploadRequest = await API_UPLOAD("action/uploadAssets", formData);
        if (uploadRequest.success) {
          // Merge new attachments with existing ones
          const newAttachments = uploadRequest.data || [];
          finalFormValue.attachments = [...(formValue.attachments || []), ...newAttachments];
        }
      }

      // Set customer details
      finalFormValue.customerPhone = finalFormValue.selectAdminObj && finalFormValue.selectAdminObj.data
        ? finalFormValue.selectAdminObj.data.phone
        : user.phone;
      finalFormValue.customerEmail = finalFormValue.selectAdminObj && finalFormValue.selectAdminObj.data
        ? finalFormValue.selectAdminObj.data.email
        : user.email;

      // Prepend customer details to comment
      if (!editMode && finalFormValue.comment) {
         const customerDetails = `Customer: ${finalFormValue.customerEmail || 'N/A'} | ${finalFormValue.customerPhone || 'N/A'} | Admin: ${finalFormValue.admin || 'N/A'}`;
         finalFormValue.comment = `${customerDetails}\n\n${finalFormValue.comment}`;
      }

      finalFormValue.RMPhone = user.allocatedToRM && user.allocatedToRM.phone;
      finalFormValue.RMEmail = user.allocatedToRM && user.allocatedToRM.email;

      if (!user.is_superuser) finalFormValue.sendNotify = true;

                  // Call external appointments API if a meeting is scheduled
      const meetingsSchedule = {
        start: "",
        end: "",
      }
      try {
        if (this.state.bookingDate && this.state.bookingSlot) {
          const url = process.env.REACT_APP_APPOINTMENTS_URL || 'https://calender.betyphon.in/index.php/api/v1/appointments';
          const token = process.env.REACT_APP_APPOINTMENTS_TOKEN || "3242424f32r3f24242342f3r2323";
          const pad = (n) => String(n).padStart(2, '0');
          // parse bookingSlot like "10:00 AM" into hours & minutes
          const [time, modifier] = this.state.bookingSlot.split(' ');
          let [hours, minutes] = time.split(':').map(Number);
          if (modifier === 'PM' && hours !== 12) hours += 12;
          if (modifier === 'AM' && hours === 12) hours = 0;

          const dt = this.state.bookingDate instanceof Date ? this.state.bookingDate : new Date(this.state.bookingDate);
          dt.setHours(hours, minutes, 0, 0);
          const endDt = new Date(dt.getTime() + 30 * 60000);

          const startStr = `${dt.getFullYear()}-${pad(dt.getMonth()+1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(dt.getMinutes())}:00`;
          const endStr = `${endDt.getFullYear()}-${pad(endDt.getMonth()+1)}-${pad(endDt.getDate())} ${pad(endDt.getHours())}:${pad(endDt.getMinutes())}:00`;
          meetingsSchedule.start = startStr;
          meetingsSchedule.end = endStr;
          finalFormValue.scheduledTime = meetingsSchedule.start;
          await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              ...(token ? { Authorization: `Bearer ${token}` } : {})
            },
            body: JSON.stringify({
              serviceId: 1,
              providerId: 2,
              customerId: 3,
              start: startStr,
              end: endStr,
              location: 'Meeting Room 1',
              notes: `Customer details - ${finalFormValue.customerEmail} ${finalFormValue.customerPhone}`,
            }),
          });
        }
      } catch (e) {}

      // Send notifications
      const notificationPromises = [];
      if (finalFormValue.RMPhone && finalFormValue.RMEmail && finalFormValue.sendNotify) {
        notificationPromises.push(
          this.sendNotification({
            ...(finalFormValue.scheduledTime ? { scheduledTime: meetingsSchedule } : {}),
            data: finalFormValue,
            phone: finalFormValue.RMPhone,
            email: finalFormValue.RMEmail,
            userType: "RM_MANAGER",
          })
        );
      }

      if (finalFormValue.sendNotify) {
        notificationPromises.push(
          this.sendNotification({
            ...(finalFormValue.scheduledTime ? { scheduledTime: meetingsSchedule } : {}),
            data: finalFormValue,
            phone: finalFormValue.customerPhone,
            email: finalFormValue.customerEmail,
            userType: "USER",
          })
        );
      }

      await Promise.all(notificationPromises);

      // Save the record to database
      let registerRequest;
      if (editMode && editId) {
        registerRequest = await API_POST("action/update", {
          root: "supportTickets",
          body: finalFormValue,
          querydata: { id: editId }
        });
      } else {
        registerRequest = await API_POST("action/addRecord", {
          root: "supportTickets",
          body: finalFormValue,
        });
      }

      if(!editMode && !user.is_superuser && finalFormValue.isPaid && monthlyTicketCount <= 0){
        await API_POST("register/changeRefer", {
          id: user.admin_id,
          updateParameter: "ticketCredits",
          ticketCredits: paidTicketCredits - 1,
        });
      }



      // Notification Bell
      await this.notificationBell({
        admin: "mark@gmail.com",
        message: `Query Raised By - ${finalFormValue.admin} Category -${finalFormValue.category} Concern - ${finalFormValue.subCategory}`,
        status: finalFormValue.status,
        category: finalFormValue.category,
        manager: finalFormValue.RMEmail,
        customer: finalFormValue.customerEmail,
      });

      this.showNotification("Thank you for raising a support ticket. Our team will get in touch with you shortly.", "success");

      return finalFormValue;
    } catch (error) {
      console.error("Error saving ticket:", error);
      throw error;
    }
  };

  handleSkipFeedback = async () => {
    const { notificationDetails } = this.state;

    try {
      // Save the ticket to database without feedback
      await this.saveTicketToDatabase(notificationDetails, false);

      // Close popup and reset form
      this.setState({
        showFeedbackForm: false,
        notificationDetails: this.DEFAULT_DATA,
        selectedFiles: [],
        ticketSubmitted: false,
      });

      this.props.loadData(0);
      this.props.setPop();

      //alert("Your ticket has been submitted successfully.");

    } catch (error) {
      console.error("Error saving ticket:", error);
      alert("Error saving ticket. Please try again.");
    }
  };


  isFieldEnabled = (fieldName) => {
    const { user } = this.props;
    const { fieldsEnables } = this.state;
    return (
      user.is_superuser || (fieldsEnables && fieldsEnables.includes(fieldName))
    );
  };

  renderField = (fieldName,girdNeed = true) => {
    const config = FIELD_CONFIG[fieldName];
    if (!config || !this.isFieldEnabled(fieldName)) return null;
    if (config.condition && !config.condition(this.props)) return null;

    return (
      <>
        {girdNeed ? (
          <GridItem key={fieldName} {...config.gridSize}>
          {config.render({
            value: this.state.notificationDetails[fieldName],
            onChange: this.handleChange,
            category: this.state.category || [],
            onCategoryChange: this.categoryChange,
            isDisabledField: this.isDisabledField,
            user: this.props.user,
            ticketAssignedToOption: this.props.ticketAssignedToOption,
            subcatoption: this.state.subcatoption,
            notificationDetails: this.state.notificationDetails,
            editMode: this.props.editMode,
            ...this.state,
          })}
        </GridItem>
        ) : (
          <>
            {config.render({
              value: this.state.notificationDetails[fieldName],
              onChange: this.handleChange,
              category: this.state.category || [],
              onCategoryChange: this.categoryChange,
              isDisabledField: this.isDisabledField,
              user: this.props.user,
              ticketAssignedToOption: this.props.ticketAssignedToOption,
              subcatoption: this.state.subcatoption,
              notificationDetails: this.state.notificationDetails,
              editMode: this.props.editMode,
              ...this.state,
            })}
          </>
        )}
      </>

    );
  };

  renderAdminField = () => {
    const { user, allUser } = this.props;
    const { notificationDetails, editMode } = this.state;

    if (!this.isFieldEnabled("admin")) return null;

    if (editMode) {
      return (
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Subscriber Id *"
            id="admin"
            formControlProps={{ fullWidth: true }}
            labelProps={{ shrink: true }}
            inputProps={{
              name: "admin",
              type: "text",
              value: notificationDetails.admin,
              disabled: true,
            }}
          />
        </GridItem>
      );
    }

    if (
      !notificationDetails.externalQuery &&
      user.is_superuser &&
      allUser &&
      allUser.length
    ) {
      return (
        <GridItem xs={12} sm={12} md={12}>
          <Autocomplete
            limitTags={1}
            options={allUser}
            name="admin"
            getOptionLabel={(option) => option.title}
            value={notificationDetails.selectAdminObj}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Subscriber Id"
                placeholder="Subscriber Id"
              />
            )}
            id="admin"
            onChange={(event, newValue) => this.changeAdmin(newValue)}
            sx={{ width: "100%" }}
          />
        </GridItem>
      );
    }
    return null;
  };

  renderAdminOnlyFields = () => {
    return [
      "adminComment",
      "status",
      "sendNotify",
      "ticketAssignedTo",
    ].map((field) => this.renderField(field));
  };

  renderExternalQueryFields = () => {
    return ["product", "company", "phone", "externalAdmin"]
      .filter((field) => this.isFieldEnabled(field))
      .map((field) => this.renderField(field));
  };

  renderSectionHeader = (title, subtitle) => (
    <>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', background:'#eff4fb', border:'1px solid #e3e9f4', borderRadius:8, padding:'12px 16px', marginTop:24, marginBottom:12 }}>
        <Typography variant="h6" style={{ margin: 0, fontWeight: 600 }}>{title}</Typography>
        <div style={{ display:'flex', gap:16, alignItems:'center' }}>
          <Typography style={{ color:'#2e7d32', fontWeight:600 }}>Free Tickets – {this.props.monthlyTicketCount || 0}</Typography>
          <Typography style={{ color:'#1976d2', fontWeight:600 }}>Paid Tickets – {this.props.paidTicketCredits || 0}</Typography>
          {this.renderField("sendNotify",false)}
        </div>
      </div>
      {subtitle && (
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
          {subtitle}
        </Typography>
      )}
    </>
  );

  renderAttachments = () => {
    const { editMode, classes, editId } = this.props;
    const { notificationDetails, selectedFiles } = this.state;

    const getFileIcon = (fileName) => {
      const ext = fileName.split('.').pop().toLowerCase();
      if (['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(ext)) return <Icon className={classes.fileIcon}>image</Icon>;
      if (['pdf'].includes(ext)) return <Icon className={classes.fileIcon}>picture_as_pdf</Icon>;
      if (['doc', 'docx'].includes(ext)) return <Icon className={classes.fileIcon}>description</Icon>;
      if (['xls', 'xlsx'].includes(ext)) return <Icon className={classes.fileIcon}>table_chart</Icon>;
      return <Icon className={classes.fileIcon}>insert_drive_file</Icon>;
    };

    return (
      <div style={{ marginTop: 16 }}>
        <GridContainer spacing={2} alignItems="center">
          <GridItem xs={12}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
              <label htmlFor="attachment-input" style={{ cursor: 'pointer', marginRight: '-4px' }}>
                <Button
                  variant="contained"
                  component="span"
                  color="primary"
                  startIcon={<AttachFile />}
                  style={{ textTransform: 'none', fontWeight: 600, borderRadius: 8, padding: 9 }}
                >
                  Attachments
                </Button>
              </label>
              <input
                accept="*/*"
                id="attachment-input"
                type="file"
                multiple
                onChange={(e) => {
                  this.handleFileChange(e);
                  e.target.value = null; // Reset to allow re-selecting same file
                }}
                style={{ display: 'none' }}
              />

            </div>
          </GridItem>
        </GridContainer>

        <GridContainer spacing={2}>
                     {(selectedFiles.length > 0 || (notificationDetails && notificationDetails.attachments && notificationDetails.attachments.length > 0)) && (
                <span className={classes.fileBadge}>
                  {selectedFiles.length + (notificationDetails && notificationDetails.attachments ? notificationDetails.attachments.length : 0)} Files
                </span>
              )}

        </GridContainer>
      </div>
    );
  };

  renderOtpSection = () => {
    const { notificationDetails } = this.state;
    if (notificationDetails.status !== "Resolved") return null;
    return (
      <Paper elevation={2} style={{ padding: 20, marginTop: 24, marginBottom: 24 }}>
        <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 500 }}>
          OTP Verification
        </Typography>
        <GridContainer spacing={2} alignItems="center">
          <GridItem xs={12} sm={6} md={4} style={{ display: 'flex', alignItems: 'center' }}>
            <Button color="primary" size="sm" onClick={this.sendOtp} style={{ marginBottom: 8, minWidth: 120 }}>
              Send OTP
            </Button>
          </GridItem>
          <GridItem xs={12} sm={6} md={8}>
            <CustomInput
              labelText="OTP"
              id="otp"
              formControlProps={{ fullWidth: true }}
              labelProps={{ shrink: true }}
              inputProps={{
                name: "otp",
                type: "text",
                onChange: this.handleChange,
                placeholder: "Enter OTP received",
                "aria-label": "OTP input field"
              }}
            />
          </GridItem>
        </GridContainer>
      </Paper>
    );
  };

  renderBookingSection = (isMobile) => {
    const { bookingDate, bookingSlot, availableSlots, loadingSlots } = this.state;

    const days = Array.from({ length: 5 }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() + i);
      const iso = d.toISOString().split('T')[0];
      const label = d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      return { iso, label, date: d };
    }).filter(day => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return day.date >= today;
    });

    return (
      <Paper elevation={2} style={{ padding: isMobile ? 12 : 20, background: '#fafbfc' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
          <Button color="success" onClick={this.toggleBookCall} style={{ background:'#2e7d32', color:'#fff', minWidth:160 }}>
            Schedule Meeting
          </Button>
           {!this.state.showFeedbackForm && (
            <Button 
              style={{ background:'#fb8c00', color:'#fff' }} 
              onClick={() => {
                this.setState({ 
                  loadingFeedback: true,
                  notificationDetails: {
                    ...this.state.notificationDetails,
                    feedbackOption: null,
                    feedbackRemarks: null
                  }
                });
                setTimeout(() => {
                  this.setState({ showFeedbackForm: true, loadingFeedback: false });
                }, 1000);
              }}
              disabled={this.state.loadingFeedback}
            >
              {this.state.loadingFeedback ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <Icon className="fa fa-spinner fa-spin" style={{ fontSize: 16 }} />
                  Opening...
                </div>
              ) : (
                "Share Feedback"
              )}
            </Button>
          )}
        
         
        </div>
        <Collapse in={this.state.showScheduler}>
          <Divider style={{ marginBottom: 16 }} />
          <GridContainer spacing={isMobile ? 1 : 2} alignItems="center">
          <GridItem xs={12} sm={8}>
                <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
              Select Date
            </Typography>
            <TextField
              label=""
              type="date"
              fullWidth
              size="small"
              value={bookingDate || ""}
              onChange={this.handleBookingDateChange}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                min: new Date().toISOString().split('T')[0]
              }}
              variant="outlined"
            />
          </GridItem>
          <GridItem xs={12} sm={4}>
            <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
              Select Slot
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={bookingSlot}
              disabled={loadingSlots}
              variant="outlined"
              onChange={(e) => this.handleSlotSelect(e.target.value)}
              SelectProps={{
                MenuProps: { PaperProps: { style: { maxHeight: 220 } } }
              }}
              InputProps={{
                startAdornment: loadingSlots ? (
                  <Icon className="fa fa-spinner fa-spin" style={{ fontSize: 16, marginRight: 8 }} />
                ) : null
              }}
            >
              {loadingSlots ? (
                <MenuItem disabled>Loading slots...</MenuItem>
              ) : availableSlots.length > 0 ? (
                availableSlots.map((slot) => (
                  <MenuItem key={slot} value={slot}>
                    {slot}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No slots available for this date</MenuItem>
              )}
            </TextField>
          
          </GridItem>
          <br/>
           {bookingDate && bookingSlot && (
            <Typography variant="body2" style={{ color:'#333', marginTop:8 }}>
              Booked Time Slot – {bookingDate} {bookingSlot}
            </Typography>
          )}
        </GridContainer>
        </Collapse>
      </Paper>
    );
  };

  renderInlineFeedback = () => {
    const { notificationDetails } = this.state;
    const feedbackOptions = [
      "Incomplete information about query",
      "More Simplified with Video",
      "Language issue",
      "Others"
    ];
    return (
      <Paper elevation={1} style={{ padding: 16, borderRadius: 8, background: '#fff' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom: 12 }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            Feedback
          </Typography>
        </div>
        <FormControl component="fieldset" style={{ width: '100%' }}>
          <RadioGroup
            value={notificationDetails.feedbackOption || ""}
            style={{ display: 'inline', flexDirection: 'column' }}
            onChange={(e) => this.handleChange({ target: { name: 'feedbackOption', value: e.target.value } })}
          >
            {feedbackOptions.map((option, index) => (
              <FormControlLabel
                key={index}
                value={option}
                control={<Radio color="primary" />}
                label={<Typography style={{ fontSize: '14px', fontWeight: 500 }}>{option}</Typography>}
                style={{ marginBottom: 8 }}
              />
            ))}
          </RadioGroup>
        </FormControl>
        {notificationDetails.feedbackOption === "Others" && (
          <TextField
            label="Please specify your feedback"
            multiline
            rows={3}
            fullWidth
            value={notificationDetails.feedbackRemarks || ""}
            onChange={(e) => this.handleChange({ target: { name: 'feedbackRemarks', value: e.target.value } })}
            variant="outlined"
            placeholder="Provide your specific feedback"
            style={{ marginTop: 12 }}
          />
        )}
      </Paper>
    );
  };

  renderMappingPopup = () => {
    const { showMappingPopup, editId } = this.state;
    return (
      showMappingPopup && (
        <>
        </>
      )
    );
  };



  // Separate component for responsive wrapper to prevent re-creation on every render
  ResponsiveWrapper = () => {
    const theme = useTheme();
    const { classes } = this.props;
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isSm = useMediaQuery(theme.breakpoints.down('sm'));
    const isMd = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = isXs || isSm;

    // Support/customer trust messages
    const supportMessages = [
      "We're here to help you—your satisfaction is our top priority.",
      "Our support team is dedicated to resolving your concerns quickly and professionally.",
      "Trust is the foundation of our service—let us know how we can assist you today.",
      "Your feedback and issues matter to us. We're committed to your success.",
      "Every support request is an opportunity to build a better experience for you."
    ];
    const randomMessage = supportMessages[Math.floor(Math.random() * supportMessages.length)];

    const notificationDetails = this.state.notificationDetails;
    return (
      <Card>
        <CardHeader color="white" style={{ paddingBottom: 0 }}>
          <GridContainer alignItems="center" justify="space-between">
            <GridItem xs={12} md={6}>
              <Typography variant="h5" style={{ margin: 0, fontWeight: 600, fontSize: isMobile ? 18 : 24 }}>
                Raise Your Support Ticket
              </Typography>
            </GridItem>
          </GridContainer>
        </CardHeader>
        <CardBody style={{ display: 'flex', flexDirection: 'column', padding: isMobile ? 8 : 24 }}>
          <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', width: '100%' }}>
            {/* Common/User Fields */}
            <Paper elevation={2} style={{ padding: isMobile ? 12 : 28, marginBottom: isMobile ? 16 : 32, background: '#fafbfc', width: '100%' }}>
              {this.renderSectionHeader("Ticket Details")}
              <GridContainer spacing={isMobile ? 1 : 3} alignItems="flex-start">
                {/* External query fields if present */}
                {this.state.notificationDetails.externalQuery && this.renderExternalQueryFields()}

                <GridItem xs={12} sm={8} style={{ marginBottom: 16 }}>
                  <div style={{ marginBottom: 16 }}>{this.renderField("ticketAssignedTo")}</div>
                </GridItem>

                {this.props.user.is_superuser ? (
                  <GridItem xs={12} sm={4} style={{ marginBottom: 16 }}>
                    <div style={{ marginBottom: 16 }}>{this.renderField("product")}</div>
                  </GridItem>
                ) : null}

                <GridItem xs={12} sm={isMobile ? 12 : 6} md={6} style={{ marginBottom: 16 }}>
                  {this.renderField("category")}
                </GridItem>
                <GridItem xs={12} sm={isMobile ? 12 : 6} md={6} style={{ marginBottom: 16 }}>
                  {this.renderField("subCategory")}
                </GridItem>

                {/* Admin/User selection */}
                <GridItem xs={12} style={{ marginBottom: 16 }}>
                  {this.renderAdminField()}
                </GridItem>

                {/* Message/Comment */}
                <GridItem xs={12} style={{ marginBottom: 16 }} container spacing={2}>
                  <GridItem xs={4} style={{ marginBottom: 16 }}>
 {/* Attachments */}
               
                  {this.renderAttachments()}
               
                  </GridItem>
                  <GridItem xs={8} style={{ marginBottom: 16 }}>
  {this.renderField("comment")}
                  </GridItem>
                
                </GridItem>

               

                {
                  this.state.notificationDetails.scheduleMeeting && (
                    <GridItem xs={12} style={{ marginBottom: 16 }}>
                      {this.renderBookingSection(isMobile)}
                    </GridItem>
                  )
                }


                {
                  this.state.notificationDetails.needFeedback && this.state.showFeedbackForm && ( this.state.notificationDetails.knowledgeLink || this.state.notificationDetails.videoLink) && (
                    <GridItem xs={12} style={{ marginBottom: 16 }}>
                      {this.renderInlineFeedback()}
                    </GridItem>
                  )
                }


                <GridItem xs={12} style={{ marginBottom: 16, textAlign: 'center' }}>
                  <Button color="primary" size="lg" onClick={this.handleSave} style={{ background:'#1e88e5', color:'#fff', marginRight: isMobile ? 8 : 24, minWidth: isMobile ? 140 : 180, fontWeight: 600 }}>
                    {this.props.editMode ? "Update" : "Submit Ticket"}
                  </Button>
                </GridItem>
                <GridItem xs={12} style={{ marginBottom: 16, textAlign: 'center' }}>
                  <Typography variant="body1" style={{ color: '#666', fontStyle: 'italic', marginTop: 8, marginBottom: 12, fontSize: isMobile ? 13 : 16 }}>
                    Note : Incase of FREE ticket count is over than each TICKET will be chargable.
                  </Typography>
                </GridItem>
              </GridContainer>
            </Paper>

            {/* Side info panel */}
            <Paper
              elevation={2}
              style={{
                background: (this.state.videoLink || notificationDetails.knowledgeLink) ? '#fff' : '#e3f2fd',
                padding: (this.state.videoLink || notificationDetails.knowledgeLink) ? 0 : (isMobile ? '12px 10px' : '28px 32px'),
                borderRadius: 12,
                margin: isMobile ? '16px 0' : 32,
                width: '100%',
                maxWidth: 645,
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                border: (this.state.videoLink || notificationDetails.knowledgeLink) ? '1px solid #ffe58f' : 'none'
              }}
            >
              {(this.state.videoLink || notificationDetails.knowledgeLink) ? (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {/* Mockup Header */}
                  <div style={{ 
                    background: '#fffbe6', 
                    padding: '16px 20px', 
                    borderBottom: '1px dashed #ffe58f', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    gap: 12
                  }}>
                    <Warning style={{ color: '#faad14', fontSize: "5.2rem" }} />
                    <Typography variant="h5" style={{ fontWeight: 800, color: '#262626', textAlign: 'center', lineHeight: 1.2, fontSize: "1.6rem" }}>
                      Before Raising a Ticket – <br/> Watch This Quick Guide!
                    </Typography>
                  </div>

                  <div style={{ padding: isMobile ? 16 : 24 }}>
                    {/* Video Section */}
                    {this.state.videoLink && (
                      <div style={{ marginBottom: 20 }}>
                        <div style={{ 
                          borderRadius: 8, 
                          overflow: 'hidden', 
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          backgroundColor: '#000',
                          position: 'relative',
                          paddingTop: '56.25%' /* 16:9 Aspect Ratio */
                        }}>
                          <iframe 
                            style={{ 
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              border: 0 
                            }} 
                            src={this.state.videoLink} 
                            title="YouTube video player" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            allowFullScreen
                          ></iframe>
                        </div>
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 16 }}>
                          <CheckCircle style={{ color: '#52c41a', fontSize: 20 }} />
                          <Typography style={{ color: '#52c41a', fontWeight: 600, fontSize: 16 }}>
                            Step 1: Watch Demo Video <span style={{ fontStyle: 'italic', fontWeight: 400 }}>(Completed)</span>
                          </Typography>
                        </div>
                      </div>
                    )}

                    {/* Knowledge Guide Section */}
                    {notificationDetails.knowledgeLink && (
                      <div style={{ textAlign: 'center', marginTop: 8 }}>
                        <a 
                          href={notificationDetails.knowledgeLink} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          style={{ textDecoration: 'none' }}
                        >
                          <Button 
                            fullWidth
                            className={classes.blinkingButton}
                            style={{ 
                              background: 'linear-gradient(180deg, #34aadc 0%, #007aff 100%)', 
                              color: '#fff', 
                              padding: '12px 20px', 
                              borderRadius: 12,
                              fontSize: isMobile ? 16 : 18,
                              fontWeight: 700,
                              textTransform: 'none',
                              boxShadow: '0 4px 14px rgba(0,122,255,0.39)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 12
                            }}
                          >
                            <Icon className="fa fa-hand-o-up" style={{ fontSize: 24, transform: 'rotate(90deg)' }} />
                              Open Step-by-Step Setup Guide
                          </Button>
                        </a>

                        <div style={{ marginTop: 20, textAlign: 'left', paddingLeft: isMobile ? 0 : 20 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                            <CheckCircle style={{ color: '#52c41a', fontSize: 18 }} />
                            <Typography style={{ color: '#262626', fontWeight: 500 }}>Official Betyphon Guide</Typography>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <CheckCircle style={{ color: '#52c41a', fontSize: 18 }} />
                            <Typography style={{ color: '#262626', fontWeight: 500 }}>Takes only 2-3 minutes to read</Typography>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ padding: isMobile ? 16 : 24, textAlign: 'center' }}>
                  <img src={CallCenter} alt="Support" style={{ width: '100%', maxWidth: 400, marginBottom: 20 }} />
                  <Typography variant="h6" style={{ color: '#1565c0', fontWeight: 600, lineHeight: 1.5 }}>
                    {randomMessage}
                  </Typography>
                </div>
              )}
            </Paper>
          </div>
        </CardBody>
        <CardFooter style={{ justifyContent: "center", padding: isMobile ? 12 : 32, background: '#fff', borderTop: '1px solid #eee' }}>
        </CardFooter>
      </Card>
    );
  };

  render() {
    return (
      <>
        <this.ResponsiveWrapper />
        <Dialog
          open={this.state.snackbarOpen}
          onClose={this.handleSnackbarClose}
          PaperProps={{
            style: {
              borderRadius: 12,
              padding: '10px',
              maxWidth: '400px',
              textAlign: 'center'
            }
          }}
        >
          <div style={{ position: 'relative' }}>
            <IconButton 
              onClick={this.handleSnackbarClose} 
              style={{ position: 'absolute', right: -5, top: -5, color: '#999' }}
              size="small"
            >
              <Close />
            </IconButton>
            
            <DialogContent style={{ paddingTop: 30 }}>
              <div style={{ marginBottom: 20 }}>
                {this.state.snackbarSeverity === "success" ? (
                  <CheckCircle style={{ fontSize: 80, color: '#4caf50' }} />
                ) : this.state.snackbarSeverity === "warning" ? (
                  <Warning style={{ fontSize: 80, color: '#ff9800' }} />
                ) : (
                  <ErrorOutline style={{ fontSize: 80, color: '#f44336' }} />
                )}
              </div>
              
              <Typography variant="h5" style={{ fontWeight: 'bold', color: '#f57c00', marginBottom: 15 }}>
                {this.state.snackbarSeverity === "success" 
                  ? "Ticket Submitted Successfully!" 
                  : this.state.snackbarSeverity === "warning" 
                    ? "Quota Limit Reached!" 
                    : "Action Required!"}
              </Typography>
              
              <Divider style={{ margin: '15px 0' }} />
              
              <Typography style={{ color: '#555', fontSize: 16, marginBottom: 25, lineHeight: 1.6 }}>
                {this.state.snackbarMessage}
              </Typography>
              
              <Button 
                onClick={this.handleSnackbarClose} 
                style={{ 
                  background: 'linear-gradient(to right, #f57c00, #ff9800)', 
                  color: 'white', 
                  fontWeight: 'bold',
                  padding: '12px 40px',
                  borderRadius: 8,
                  fontSize: 18,
                  textTransform: 'none',
                  boxShadow: '0 4px 10px rgba(245, 124, 0, 0.3)'
                }}
                fullWidth
              >
                Okay, Got It
              </Button>
            </DialogContent>
          </div>
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles)(SupportForm);